import { EmptyState } from "components/common/modals/modal.styles";
import { Section, SectionHeader, SectionTitle } from "components/common/Section/index.styles";
import styled from "styled-components";


export const EventsSection = Section

export const EventsSectionHeader = SectionHeader

export const EventsSectionTitle = SectionTitle

export const EventsEmptyState = EmptyState


